{
  "page_count": "no {n, plural, one{# lpp.} other{# lpp.}}"
}
